import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgLocation = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-location';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M11.34 2.28c-2.758.198-5.31 1.749-6.785 4.124a9.4 9.4 0 0 0-1.054 2.513c-.319 1.267-.327 2.81-.019 4.1.189.794.66 1.961.967 2.395.091.129 7.494 6.548 7.551 6.548.037 0 7.049-6.048 7.392-6.376.271-.259.686-1.118.962-1.989.834-2.636.33-5.579-1.341-7.823-1.376-1.848-3.509-3.114-5.773-3.427a10.4 10.4 0 0 0-1.9-.065m1.892 1.576a7.25 7.25 0 0 1 3.883 2.029 7.1 7.1 0 0 1 2.113 5.375c-.04 1.103-.233 1.899-.693 2.864l-.184.385-3.159 2.735C13.454 18.749 12.018 19.98 12 19.98s-1.454-1.231-3.193-2.736l-3.16-2.735-.201-.425c-.724-1.526-.88-3.265-.446-4.964.623-2.438 2.723-4.519 5.18-5.134a9 9 0 0 1 1.12-.203c.266-.037 1.615.014 1.932.073M11.29 7.282c-.455.081-1.101.361-1.51.655a4.04 4.04 0 0 0-1.194 1.407c-.301.614-.402 1.065-.398 1.776.003.404.024.577.108.9.465 1.78 2.087 2.983 3.895 2.889 1.682-.088 3.085-1.244 3.514-2.894.119-.458.145-1.21.059-1.655a4 4 0 0 0-1.544-2.425c-.258-.187-.932-.511-1.24-.595-.285-.078-1.369-.116-1.69-.058m1.173 1.481c.42.076.798.289 1.158.653.367.37.508.608.62 1.047a2.33 2.33 0 0 1-.62 2.277c-.47.469-.963.674-1.621.674s-1.151-.205-1.621-.674a2.33 2.33 0 0 1-.62-2.277c.112-.439.253-.677.62-1.047.477-.482.932-.68 1.584-.692.144-.002.369.015.5.039"
    })
  }));
});
export default SvgLocation;